module.exports = __webpack_public_path__ + "img/icone-de-coche-verte.ae350c03.png";